import { billableCalculationLabel } from "./billingCalculation.js";
import { dispatchInspectionLabel, dispatchStepLabels } from "./consolidationDispatchPresentation.js";
import { consolidationStopGroups, presentConsolidationItems } from "./consolidationCalculationPresentation.js";
import { billedPartyLabel, coopPartyNames, isCoopParty } from "./consolidationBillingParty.js";

export const consolidationMillKey = (mill = {}) => mill?.id != null ? String(mill.id) : JSON.stringify([mill?.name, mill?.address]);

// Shared presentation for individual and daily details; never recompute billing allocations.
export function consolidationCalculationMills(value, date, sheet) {
  const operational = value?.format_version === 2;
  const mills = new Map();
  // Cards show the Clients name of a Coop (live data), else the calculated name.
  const names = coopPartyNames(sheet);
  for (const charge of value?.charges || []) {
    const mill = charge.mill || {};
    const key = consolidationMillKey(mill);
    if (!mills.has(key)) mills.set(key, { label: billedPartyLabel(mill, names), coop: isCoopParty(mill), items: [] });
    const group = mills.get(key);
    const item = {
      id: charge.key, service_date: date, order_reference: charge.order_label,
      billing_unit: charge.billing_unit, quantity: charge.quantity,
      unit_rate: operational ? null : charge.unit_rate,
      line_total: operational ? null : charge.line_total,
      currency_code: charge.currency_code || "CAD", calculation_details: charge,
    };
    item.source_description = `${billableCalculationLabel(item)} · ${group.label}${charge.order_label ? ` · ${charge.order_label}` : ""}`;
    group.items.push(item);
  }
  const stopContext = {
    visits: sheet?.visits || [],
    labels: dispatchStepLabels(sheet?.dispatch_assignment, date, sheet?.dispatch_period),
    inspectionLabel: dispatchInspectionLabel(sheet?.dispatch_assignment, date, sheet?.dispatch_period),
    charges: value?.charges || [],
  };
  for (const mill of mills.values()) mill.stopGroups = consolidationStopGroups(presentConsolidationItems(mill.items, value?.presentation), stopContext);
  return mills;
}
